import React, { memo } from "react";
import { Dropdown } from "react-bootstrap";
import { HiMenuAlt1 } from "react-icons/hi";
const TableOptions = ({ tableOptions }) => {
  return (
    <Dropdown className="d-inline ">
      <Dropdown.Toggle
        id="dropdown-autoclose-true"
        className="btn-outline-secondary icon_button"
      >
        <HiMenuAlt1 size={18} />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {Object.keys(tableOptions).map((key, i) => (
          <Dropdown.Item
            href="#"
            onClick={tableOptions[key].onClick}
            key={i}
            disabled={tableOptions[key].disabled}
          >
            {key}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default memo(TableOptions);
